<template>
<q-btn-dropdown flat dense class="q-mr-sm"
                @hide="updateFilters">
  <template v-slot:label>
    <span class="text-weight-medium q-mr-sm">Gebruikers</span>
    <count-chip v-if="projectComments.filter.length" :count="projectComments.filter.length" />
  </template>
  <q-list style="min-width: 100px">
    <q-item v-for="commenter in commenters"
            clickable
            :key="commenter.id">
      <q-checkbox v-model="commenterFilter"
                  :val="commenter.id"
                  :label="`${commenter.first_name} ${commenter.last_name}`"
                  @update:model-value="filtersUpdated = true" />
    </q-item>
  </q-list>
</q-btn-dropdown>
</template>

<script>
import { useProjectComents } from '../../stores/useProjectComments'

export default {
  props: {
    commenters: {
      type: Array,
      default: () => [],
    },
  },
  setup () {
    const projectComments = useProjectComents()
    return {
      projectComments,
    }
  },
  data () {
    return {
      commenterFilter: this.projectComments.filter,
      filtersUpdated: false,
    }
  },
  methods: {
    async updateFilters () {
      if (!this.filtersUpdated) {
        return
      }
      this.projectComments.setFilter(this.commenterFilter)
    },
  },
}
</script>
